<template>
  <div>

    <div class="flex flex-wrap items-center -mx-1">
      <div class="relative w-10/12 px-1 flex-grow">
        <model-select
          :value="value"
          @input="$emit('input', $event)"
          v-bind="rule.modelSelect.propData"
          v-on="rule.modelSelect.listeners"
        />
      </div>
      <div
        v-if="value"
        class="px-2 btn btn-red px-1 w-2/12 h-8 flex items-center justify-center"
        @click="reset"
      >
        <i class="far fa-times-circle"></i>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'filter-model-select',
  props: {
    rule: {},
    value: {},
  },
  beforeCreate() {
    this.$options.components.ModelSelect = require('@/components/ModelSelect').default
  },
  methods: {
    reset() {
      this.$emit('input', this.rule.default)
      if (this.rule.modelSelect.listeners.input) {
        this.rule.modelSelect.listeners.input(this.rule.default)
      }
    }
  }
}
</script>
